export default __webpack_public_path__ + "static/media/growth.11b11d17.png";